import { HttpClientModule, HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../../auth/services/auth.service';
import { Injectable } from '@angular/core';
import { ReportService } from './report.service';
import { SettingsService } from '../../settings/services/settings.service';
import { Observable } from "rxjs/Rx";
import { ReactiveFormsModule } from '@angular/forms';
import { ReportResponse } from '../models/report-response.model';

@Injectable()
export class ReportDownloadService {
    appSettings = this.settingsService.Get();
    apiUrl = this.appSettings.apiUrl;

    constructor(private httpService: HttpClient, private authService: AuthService,
        private reportService: ReportService, private settingsService: SettingsService) {}

  getDownloadFile(activatedRoute) {
    const id = activatedRoute.snapshot.params['id'];
    const additionalParams = Object.assign({}, activatedRoute.snapshot.params);
    delete additionalParams['id'];
    return this.downloadFile(id, additionalParams);
  }

  downloadFile(id: number, additionalParams: { [key: string]: string } = {}) {
    if (this.authService.getAuthorisationHeader() == null) {
      return;
    }
    let headers = this.authService.getAuthorisationHeader();
    headers = headers.set('timeout', '240000');

    var params = new HttpParams();

    for (const key in additionalParams) {
      params = params.append(key, additionalParams[key]);
    }

    return Observable.create((observer) => {
      this.httpService
      .get(this.apiUrl + '/report/' + id, {
        headers: headers,
        params: params,
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(response => {
        const matchingReport = this.reportService.reports.find(r => r.report.id == id);
        
        observer.next(response);
        observer.complete();
      });

    });
  }

  downloadTemplate() {
    return this.httpService.get('../../../assets/templates/TEMPLATE_COMBINED_CAR_10Rows.csv', {
      responseType: 'blob',
      observe: 'response'
    });
  }

  getFilenameFromResponse(response): string {
        let fileName = response.headers.get('content-disposition').split(';')[2].split('=')[1];
        fileName = fileName.replace("UTF-8''", '');
        fileName = decodeURIComponent(fileName);
        return fileName;
  }

}



// WEBPACK FOOTER //
// ./src/app/report/services/report-download.service.ts